import React, { useState, useEffect } from 'react';
import { COLORS } from '../../utils/constants';
import { TrendingUp, TrendingDown } from 'lucide-react';

const HeaderTickerTape = () => {
  const [tickers, setTickers] = useState([]);

  useEffect(() => {
    const initialTickers = [
      { symbol: 'BTC', price: 88500, change: 2.34 },
      { symbol: 'ETH', price: 3280, change: 1.87 },
      { symbol: 'SOL', price: 125, change: 4.21 },
      { symbol: 'XRP', price: 2.28, change: 3.15 },
      { symbol: 'BNB', price: 715, change: -0.45 },
    ];
    
    setTickers(initialTickers);
    
    const interval = setInterval(() => {
      setTickers(prev => prev.map(t => ({
        ...t,
        price: t.price * (1 + (Math.random() - 0.5) * 0.002),
        change: t.change + (Math.random() - 0.5) * 0.1
      })));
    }, 3000);
    
    return () => clearInterval(interval);
  }, []);

  const formatPrice = (price) => {
    if (price >= 1000) return price.toFixed(0);
    if (price >= 1) return price.toFixed(2);
    return price.toFixed(4);
  };

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
      overflow: 'hidden',
    }}>
      {tickers.map((ticker, idx) => {
        const isPositive = ticker.change >= 0;
        return (
          <div
            key={idx}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              padding: '4px 10px',
              borderRadius: '6px',
              backgroundColor: COLORS.background,
              whiteSpace: 'nowrap',
            }}
          >
            <span style={{ 
              color: COLORS.text, 
              fontSize: '12px', 
              fontWeight: '700',
            }}>
              {ticker.symbol}
            </span>
            <span style={{ 
              color: COLORS.textSecondary, 
              fontSize: '12px',
              fontFamily: 'monospace',
            }}>
              ${formatPrice(ticker.price)}
            </span>
            <span style={{
              display: 'flex',
              alignItems: 'center',
              gap: '2px',
              color: isPositive ? COLORS.success : COLORS.danger,
              fontSize: '11px',
              fontWeight: '600',
            }}>
              {isPositive ? <TrendingUp size={10} /> : <TrendingDown size={10} />}
              {isPositive ? '+' : ''}{ticker.change.toFixed(2)}%
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default HeaderTickerTape;
